module.exports = __webpack_public_path__ + "img/thumb_16.031de913.jpg";